// src/lenis.js
import Lenis from "@studio-freight/lenis";

// Créer une instance unique de Lenis
const lenis = new Lenis({
    duration: 1.2,
    smooth: true,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Exponential ease-out
});

// Fonction pour animer Lenis dans une boucle de rafraîchissement
function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

export default lenis; // Export de l'instance
